/**
 * FilterTreeByDataTypeDataClass in place a tree from jcampconverter
 * @param tree jca
 * @param filter
 * @returns
 */
export function filterJcampTree(tree, options = {}) {
    const newTree = [];
    for (let branch of isNmrDataType(tree, options) ? tree : []) {
        if (branch.dataType === 'LINK') {
            branch.children = filterChildren(branch.children, options);
        }
        else {
            branch = filterChildren([branch], options)[0];
        }
        newTree.push(branch);
    }
    const { name, logger } = options;
    if (tree.length === 0 && logger) {
        logger.warn(`There is no spectra ${name ? `in ${name}` : 'in the JCAMP-DX'}`);
    }
    return newTree;
}
function isNmrDataType(tree, options = {}) {
    const { logger, name = '' } = options;
    for (const branch of tree) {
        const children = branch.dataType === 'LINK' ? branch.children : [branch];
        for (const child of children) {
            const { dataType } = child;
            if (dataType && !dataType.toLowerCase().includes('nmr')) {
                if (logger) {
                    logger.warn(`File ${name} was ignored because it is a ${dataType}`);
                }
                return false;
            }
        }
    }
    return true;
}
function filterChildren(children, options = {}) {
    const { tree: filters = [], dataSelection = 'both' } = options;
    const partialResult = children.filter((child) => {
        const { dataType: childDataType, dataClass: childDataClass } = child;
        return !filters.some((filter) => {
            const { dataClass = childDataClass, dataType = childDataType } = filter;
            return childDataClass === dataClass && childDataType === dataType;
        });
    });
    const newChildren = [];
    const hasFid = partialResult.some(isItFid);
    const hasFt = partialResult.some(isItFt);
    for (const child of partialResult) {
        if (dataSelection !== 'both') {
            if (isItFid(child)) {
                if (dataSelection === 'ft')
                    continue;
                if (dataSelection === 'preferFT' && hasFt)
                    continue;
            }
            if (isItFt(child)) {
                if (dataSelection === 'fid')
                    continue;
                if (dataSelection === 'preferFID' && hasFid)
                    continue;
            }
        }
        newChildren.push(child);
    }
    return newChildren;
}
function isItFt(child) {
    return (child.dataType &&
        child.dataType.toUpperCase().includes('SPECTRUM') &&
        child.dataClass &&
        !child.dataClass.toUpperCase().includes('PEAK'));
}
function isItFid(child) {
    return child.dataType && child.dataType.toUpperCase().includes('FID');
}
//# sourceMappingURL=filterJcampTree.js.map